"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    select: {
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        borderRadius: 50,
        backgroundColor: colors_1.default.WHITE,
        margin: 3,
        width: 75,
        height: 40,
    },
});
exports.default = styles;
